import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles.css";

const root = document.getElementById("root");

if (root === null) {
  throw new Error("Le point de montage React #root est introuvable.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
